var default_styles_default = {
  "button_container": "jMIKq",
  "button_text": "sh1FW",
  "button_size_content": "dS3Yc"
};
export {
  default_styles_default as default
};
//# sourceMappingURL=default-styles-scss.js.map
